import React, { useState, useCallback } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import {
  Admin,
  AgencyAdmin,
  AgencyDescription,
  AgencyDisplay,
  Organisation,
  User,
  Website,
} from "./modules";
import { AdminContext } from "./context/admin-context";
import { AuthContext } from "./context/auth-context";

function App() {
  const [loggedin, setLoggedIn] = useState(false);
  const [loggedInAdmin, setLoggedInAdmin] = useState(false);
  const [adminData, setAdminData] = useState(null);
  const [userData, setUserData] = useState({});
  const login = useCallback(() => {
    setLoggedIn(true);
  }, []);
  const loginAdmin = useCallback((item) => {
    setLoggedInAdmin(true);
  }, []);
  const logout = useCallback(() => {
    setLoggedIn(false);
  }, []);
  const logoutAdmin = useCallback(() => {
    setLoggedInAdmin(false);
  }, []);

  const adminDataSet = useCallback((item) => {
    setAdminData(item);
  }, []);

  const userDataSet = useCallback((user) => {
    setUserData(user);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        isloggedIn: loggedin,
        login: login,
        logout: logout,
        customerUserData: userData,
        customerLoadData: userDataSet,
      }}
    >
      <AdminContext.Provider
        value={{
          isloggedIn: loggedInAdmin,
          login: loginAdmin,
          logout: logoutAdmin,
          adminUserInfo: adminDataSet,
          adminUserData: adminData,
        }}
      >
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Website />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/driversFriendMobile" element={<User />} />
            <Route path="/organisation" element={<Organisation />} />
            <Route path="/agency" element={<AgencyDisplay />} />
            <Route path="/agency-breakdown" element={<AgencyDescription />} />
            <Route path="/agency-admin" element={<AgencyAdmin />} />
          </Routes>
        </BrowserRouter>
      </AdminContext.Provider>
    </AuthContext.Provider>
  );
}

export default App;
